/** ConX unit type.
 * API-wise, any string is accepted to support other unit types.
 * See global definition: @/domain/entityTypes.js
 */
export enum AwarenessUnitType {
  Vehicle = 'VEHICLE'
}